
<v-content>
  <v-row wrap class="layout">
    <v-col cols="12">
      <div class="loading" v-show="loading">
        <v-progress-circular
            :size="70"
            :width="7"
            class="animation"
            color="primary"
            indeterminate
        />
      </div>
      <v-alert :value="success" type="success">{{ $t("NEWSLETTER_UNREGISTERED_SUCCESSFULLY") }}</v-alert>
      <v-alert :value="error" type="info">{{ $t("NEWSLETTER_NOT_REGISTERED") }}</v-alert>
    </v-col>
  </v-row>
</v-content>

